document.addEventListener('DOMContentLoaded',()=>{
 document.querySelectorAll('.gallery').forEach(gallery=>{
  const main=gallery.querySelector('.gallery__main');
  const image=gallery.querySelector('.gallery__main img');
  const thumbs=[...gallery.querySelectorAll('[data-gallery-thumb]')];
  let video=null,index=0,touchStart=0;
  const show=next=>{
   if(!main||!image||!thumbs.length)return;
   index=(next+thumbs.length)%thumbs.length;
   const thumb=thumbs[index],src=thumb.dataset.src;
   if(thumb.dataset.media==='video'){
    image.hidden=true;
    if(!video){video=document.createElement('video');video.className='gallery__main-video';video.controls=true;video.autoplay=true;video.muted=true;video.loop=true;video.playsInline=true;video.preload='metadata';video.setAttribute('aria-label','Video de la fuente BAYMA');main.insertBefore(video,main.querySelector('[data-gallery-prev]'))}
    video.src=src;video.hidden=false;video.play().catch(()=>{});
   }else{
    if(video){video.pause();video.hidden=true}
    image.hidden=false;image.src=src;
    image.alt=thumb.querySelector('img')?.alt||'Bebedero automático BAYMA';
   }
   thumbs.forEach((thumb,i)=>thumb.setAttribute('aria-current',i===index?'true':'false'));
   thumbs[index].scrollIntoView({behavior:'smooth',block:'nearest',inline:'nearest'});
  };
  gallery._showImageBySrc=src=>{
   const match=thumbs.findIndex(thumb=>thumb.dataset.src===src||thumb.dataset.src.endsWith(src));
   if(match>=0)show(match);else if(image){if(video){video.pause();video.hidden=true}image.hidden=false;image.src=src}
  };
  thumbs.forEach((button,i)=>button.addEventListener('click',()=>show(i)));
  gallery.querySelector('[data-gallery-prev]')?.addEventListener('click',()=>show(index-1));
  gallery.querySelector('[data-gallery-next]')?.addEventListener('click',()=>show(index+1));
  gallery.querySelector('.gallery__main')?.addEventListener('touchstart',event=>{touchStart=event.changedTouches[0].clientX},{passive:true});
  gallery.querySelector('.gallery__main')?.addEventListener('touchend',event=>{const delta=event.changedTouches[0].clientX-touchStart;if(Math.abs(delta)>45)show(index+(delta<0?1:-1))},{passive:true});
  thumbs[0]?.setAttribute('aria-current','true');
 });
 document.querySelectorAll('[data-product-root]').forEach(root=>{
  const money=cents=>new Intl.NumberFormat('es-MX',{style:'currency',currency:'MXN'}).format(cents/100);
  const updateBundleOffer=unitPrice=>{
   const offer=root.querySelector('[data-bundle-offer]');
   if(!offer)return;
   const quantity=Number(offer.dataset.bundleQuantity||2);
   const discount=Number(offer.dataset.bundleDiscount||0);
   const shipping=Number(offer.dataset.bundleShipping||0);
   const productsRegular=unitPrice*quantity;
   const regularTotal=productsRegular+shipping;
   const offerPrice=Math.round(productsRegular*(100-discount)/100);
   const savings=regularTotal-offerPrice;
   const set=(selector,value)=>{const node=offer.querySelector(selector);if(node)node.textContent=money(value)};
   set('[data-offer-regular-total]',regularTotal);
   set('[data-offer-price]',offerPrice);
   set('[data-offer-shipping]',shipping);
   set('[data-offer-total]',offerPrice);
   set('[data-offer-savings]',savings);
  };
  const updateVariant=input=>{
   const price=Number(input.dataset.price||0),compare=Number(input.dataset.compare||0);
   const priceNode=root.querySelector('[data-current-price]');
   const compareNode=root.querySelector('[data-compare-price]');
   const badge=root.querySelector('[data-discount-badge]');
   const addButton=root.querySelector('[data-add-to-cart]');
   const addText=root.querySelector('[data-add-to-cart-text]');
   const mainImage=root.querySelector('.gallery__main img');
   const stickyPrice=root.querySelector('[data-sticky-price]');
   const stickyImage=root.querySelector('.sticky-buy__image');
   const selectedColor=root.querySelector('[data-selected-color]');
   if(priceNode) priceNode.textContent=money(price);
   if(compareNode&&badge){
    if(compare>price){compareNode.textContent=money(compare);compareNode.hidden=false;badge.textContent=Math.round((1-price/compare)*100)+'% menos';badge.hidden=false}
    else{compareNode.hidden=true;badge.hidden=true}
   }
   if(addButton){addButton.disabled=input.disabled;if(addText) addText.textContent=input.disabled?'Agotado':'Agregar al carrito'}
   if(mainImage&&input.dataset.image){const gallery=root.querySelector('.gallery');if(gallery?._showImageBySrc)gallery._showImageBySrc(input.dataset.image);else mainImage.src=input.dataset.image}
   if(stickyPrice) stickyPrice.textContent=money(price)+' MXN';
   if(stickyImage&&input.dataset.image) stickyImage.src=input.dataset.image;
   if(selectedColor) selectedColor.textContent=input.dataset.variantTitle||input.value;
   updateBundleOffer(price);
  };
  root.querySelectorAll('[data-variant-input]').forEach(input=>input.addEventListener('change',()=>updateVariant(input)));

  const form=root.querySelector('[data-product-form]');
  const totalInput=root.querySelector('[data-total-quantity]');
  const combo=root.querySelector('[data-combo-builder]');
  const comboInputs=[...root.querySelectorAll('[data-combo-qty]')];
  const comboTotal=root.querySelector('[data-combo-total]');
  const comboStatus=root.querySelector('[data-combo-status]');
  const addText=root.querySelector('[data-add-to-cart-text]');
  const clampTotal=()=>Math.max(1,Math.min(6,Number(totalInput?.value||1)));
  const resetDistribution=()=>{
   const total=clampTotal();
   if(totalInput) totalInput.value=total;
   const selectedVariant=root.querySelector('[data-variant-input]:checked');
   comboInputs.forEach(input=>input.value=input.dataset.variantId===selectedVariant?.value?total:0);
   if(comboTotal) comboTotal.textContent=total;
   if(combo) combo.hidden=total===1;
   if(addText) addText.textContent=total>1?'Agregar combinación al carrito':'Agregar al carrito';
   if(comboStatus) comboStatus.textContent='Combinación completa';
  };
  if(totalInput){
   totalInput.addEventListener('change',resetDistribution);
   totalInput.addEventListener('input',resetDistribution);
  }
  root.querySelectorAll('[data-variant-input]').forEach(input=>input.addEventListener('change',()=>{if(clampTotal()>1)resetDistribution()}));
  comboInputs.forEach(input=>input.addEventListener('input',()=>{
   const total=clampTotal();
   const value=Math.max(0,Math.min(total,Number(input.value||0)));
   input.value=value;
   const other=comboInputs.find(item=>item!==input&&!item.disabled);
   if(other) other.value=total-value;
   if(comboStatus) comboStatus.textContent='Combinación completa';
  }));
  const bundleButton=root.querySelector('[data-bundle-add]');
  if(bundleButton)bundleButton.addEventListener('click',async()=>{
   const variants=[...root.querySelectorAll('[data-variant-input]')].filter(input=>!input.disabled).slice(0,2);
   if(variants.length<2)return;
   const originalText=bundleButton.textContent;
   bundleButton.disabled=true;bundleButton.textContent='Agregando tu oferta…';
   try{
    const response=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:variants.map(input=>({id:Number(input.value),quantity:1}))})});
    if(!response.ok)throw new Error('No se pudo agregar la oferta');
    document.querySelector('[data-cart-drawer-open]')?.click();
   }catch(error){bundleButton.textContent='No pudimos agregar la oferta. Intenta nuevamente.';setTimeout(()=>{bundleButton.textContent=originalText;bundleButton.disabled=false},2200);return}
   bundleButton.textContent=originalText;bundleButton.disabled=false;
  });
  if(bundleButton){
   document.querySelectorAll('[data-bundle-cta]').forEach(cta=>{
    if(cta.dataset.bundleReady==='true')return;
    cta.dataset.bundleReady='true';
    cta.addEventListener('click',event=>{
     event.preventDefault();
     bundleButton.click();
    });
   });
  }
  const stickyBundleButton=root.querySelector('[data-sticky-bundle-add]');
  if(stickyBundleButton)stickyBundleButton.addEventListener('click',async()=>{
   const variants=[...root.querySelectorAll('[data-variant-input]')].filter(input=>!input.disabled).slice(0,2);
   if(variants.length<2)return;
   const originalText=stickyBundleButton.textContent;
   stickyBundleButton.disabled=true;stickyBundleButton.textContent='Agregando tu oferta…';
   try{
    const response=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:variants.map(input=>({id:Number(input.value),quantity:1}))})});
    if(!response.ok)throw new Error('No se pudo agregar la oferta');
    document.querySelector('[data-cart-drawer-open]')?.click();
   }catch(error){stickyBundleButton.textContent='No pudimos agregar la oferta. Intenta nuevamente.';setTimeout(()=>{stickyBundleButton.textContent=originalText;stickyBundleButton.disabled=false},2200);return}
   stickyBundleButton.textContent=originalText;stickyBundleButton.disabled=false;
  });
  if(form) form.addEventListener('submit',async event=>{
   const total=clampTotal();
   if(total===1)return;
   event.preventDefault();
   const items=comboInputs.map(input=>({id:Number(input.dataset.variantId),quantity:Number(input.value||0)})).filter(item=>item.quantity>0);
   const sum=items.reduce((value,item)=>value+item.quantity,0);
   if(sum!==total){if(comboStatus)comboStatus.textContent='Ajusta las cantidades para completar el total';return}
   const button=form.querySelector('[data-add-to-cart]');
   if(button)button.disabled=true;
   if(addText)addText.textContent='Agregando…';
   try{
    const response=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
    if(!response.ok)throw new Error('No se pudo agregar la combinación');
    window.location.href='/cart';
   }catch(error){
    if(button)button.disabled=false;
    if(addText)addText.textContent='Agregar combinación al carrito';
    if(comboStatus)comboStatus.textContent='No pudimos agregarla. Intenta nuevamente.';
   }
  });
  const stickyBuy=root.querySelector('[data-sticky-buy]');
  const stickyCheckout=stickyBuy?.querySelector('[data-sticky-checkout]');
  if(stickyCheckout)stickyCheckout.addEventListener('click',async()=>{
   const total=clampTotal();
   const selectedVariant=root.querySelector('[data-variant-input]:checked');
   const items=total>1?comboInputs.map(input=>({id:Number(input.dataset.variantId),quantity:Number(input.value||0)})).filter(item=>item.quantity>0):(selectedVariant?[{id:Number(selectedVariant.value),quantity:1}]:[]);
   if(!items.length||items.reduce((sum,item)=>sum+item.quantity,0)!==total){if(comboStatus)comboStatus.textContent='Revisa las cantidades antes de continuar';return}
   const originalText=stickyCheckout.textContent;
   stickyCheckout.disabled=true;stickyCheckout.textContent='Preparando compra…';
   try{
    const response=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
    if(!response.ok)throw new Error('No se pudo preparar la compra');
    window.location.href='/checkout';
   }catch(error){stickyCheckout.disabled=false;stickyCheckout.textContent=originalText;if(comboStatus)comboStatus.textContent='No pudimos preparar la compra. Intenta nuevamente.'}
  });
  if(stickyBuy){
   const toggleSticky=()=>{
    const scrollPosition=window.scrollY||window.pageYOffset||document.documentElement.scrollTop||0;
    stickyBuy.classList.toggle('is-visible',scrollPosition>160);
   };
   toggleSticky();
   window.addEventListener('scroll',toggleSticky,{passive:true});
   window.addEventListener('resize',toggleSticky);
  }
 });
});
